import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import { createContext, useContext } from "react";

import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

type TPaperCoinsDisclaimerContext = {
  openDisclaimer: () => void;
};

const PaperCoinsDisclaimerContext = createContext<TPaperCoinsDisclaimerContext>(
  {
    openDisclaimer: () => {},
  }
);

const PaperCoinsDisclaimer = ({ children }: { children: React.ReactNode }) => {
  const { isOpen, onClose, onOpen } = useDisclosure();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const openPricing = () => {
    navigate("/pricing");
    onClose();
  };
  return (
    <PaperCoinsDisclaimerContext.Provider value={{ openDisclaimer: onOpen }}>
      {children}
      <Modal onClose={onClose} isOpen={isOpen} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{t("papercoins.title")}</ModalHeader>
          <ModalCloseButton />
          <ModalBody display={"flex"} flexDirection={"column"} gap={2}>
            <Text>{t("papercoins.disclaimer")}</Text>
            <Text>{t("papercoins.disclaimer2")}</Text>
            <Text>{t("papercoins.archieReminder")}</Text>
            <Text>{t("papercoins.archie")}</Text>
          </ModalBody>
          <ModalFooter gap={4}>
            <Button colorScheme="brand" onClick={openPricing}>
              {t("papercoins.pricing")}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </PaperCoinsDisclaimerContext.Provider>
  );
};

const usePaperCoinsDisclaimer = () => useContext(PaperCoinsDisclaimerContext);

export { PaperCoinsDisclaimer, usePaperCoinsDisclaimer };
